// ═══════════════ FINANCES - STATIC CONSTANTS ═══════════════
// Pure data only, extracted from FinancesPage.js.

export const FAMILY_META = {
  obligatoire: { label: 'Besoins', color: '#ef4444', emoji: '🔴', target: 50 },
  non_essentiel: { label: 'Envies', color: '#fbbf24', emoji: '🟡', target: 30 },
  epargne_invest: { label: 'Épargne & Invest', color: '#00e5a0', emoji: '🟢', target: 20 },
};

export const DEST_COLORS = {
  fixed: '#ef4444',
  variable: '#f59e0b',
  epargne: '#00e5a0',
  investissement: '#4f8eff',
  provision: '#7c3aed',
};

export const ENV_TYPE_TO_CAT = { epargne: 'Épargne', investissement: 'Investissement', provision: 'Provisions' };
export const CAT_TO_TYPE = { 'Épargne': 'epargne', 'Investissement': 'investissement', 'Provisions': 'provision' };

export const DEFAULT_CATS = {
  obligatoire: {
    'Logement': ['Loyer', 'Charges', 'Assurance hab'],
    'Transport': ['Carburant', 'Assurance auto', 'Transports commun'],
    'Alimentation': ['Courses'],
    'Santé': ['Mutuelle', 'Médecin', 'Pharmacie'],
    'Abonnements essentiels': ['Internet', 'Téléphone', 'Énergie'],
  },
  non_essentiel: {
    'Restauration': ['Restaurant', 'Café', 'Livraison'],
    'Loisirs': ['Cinéma', 'Voyages', 'Sport'],
    'Shopping': ['Vêtements', 'High-tech'],
    'Abonnements non essentiels': ['Netflix', 'Spotify'],
    'Cadeaux': [],
    'Beauté': [],
  },
  epargne_invest: {
    'Épargne': ['Livret A', 'LDDS', 'PEL'],
    'Investissement': ['PEA', 'CTO', 'Crypto'],
    'Provisions': ['Voyages', 'Voiture', 'Imprévus'],
  },
};

export const CHARGE_CATS = ['Logement', 'Transport', 'Abonnements', 'Santé', 'Alimentation', 'Restauration', 'Loisirs', 'Shopping', 'Autres'];
export const PIE_COLORS = ['#00e5a0', '#4f8eff', '#7c3aed', '#f97316', '#fbbf24', '#ef4444', '#06b6d4', '#ec4899'];

export const EMPTY_BUDGET = { revenues: [], fixedCharges: [], variableCharges: [], envelopes: [] };
